import { Column } from 'react-table'
import { columnGenerators } from '../../../../../../_metronic/helpers'

// const header = [
//   {
//     label: 'S.N',
//     value: 'id',
//   },
//   {
//     label: 'logo',
//     value: 'logoCommit',
//   },
//   {
//     label: 'Date',
//     value: 'createdAt',
//   },
//   {
//     label: 'Sponsor Name',
//     value: 'sponsorNamet',
//   },
//   // {
//   //   label: 'Supply chain',
//   //   value: 'franchiseName',
//   // },
//   {
//     label: 'Package',
//     value: 'packageLogocm',
//   },
//   {
//     label: 'Household',
//     value: 'Householdcm',
//   },
//   {
//     label: 'plastic',
//     value: 'plasticPreventedcm',
//   },
//   {
//     label: 'Type',
//     value: 'commitmentTypett',
//   },
//   {
//     label: 'Environment',
//     value: 'environment',
//   },
//   {
//     label: 'Quantity',
//     value: 'quantity',
//   },
//   {
//     label: 'Completion',
//     value: '',
//   },
//   {
//     label: 'start date',
//     value: 'startDate',
//   },
//   {
//     label: 'end date',
//     value: 'endDate',
//   },
//   {
//     label: 'Status',
//     value: 'status',
//   },
//   // {
//   //   label: 'My trips',
//   //   action: ['edit'],
//   // },
//   // {
//   //   label: 'Action',
//   //   value: 'commitmentEdit',
//   // },

//     {
//     action: ['edit'],
//   }
// ]

const header = [
  {
    label: 'S.N',
    value: 'id',
  },
  {
    label: 'logo',
    value: 'logoCommit',
  },
  // {
  //   label: 'Created on',
  //   value: 'createdAtCm',
  // },
  {
    label: 'Impact Partners',
    value: 'sponsorNamet',
  },
  // {
  //   label: 'Supply chain',
  //   value: 'franchiseName',
  // },
  {
    label: 'Package',
    value: 'packageLogocm',
  },
  {
    label: 'Household',
    value: 'Householdcm',
  },
  {
    label: 'plastic (kg)',
    value: 'plasticPreventedcm',
  },
  // {
  //   label: 'Type',
  //   value: 'commitmentTypett',
  // },
  // {
  //   label: 'Environment',
  //   value: 'environment',
  // },
  // {
  //   label: 'Quantity',
  //   value: 'quantity',
  // },
  // {
  //   label: 'Completion',
  //   value: '',
  // },
  {
    label: 'start date',
    value: 'startDatecm',
  },
  {
    label: 'end date',
    value: 'endDatecm',
  },
  {
    label: 'Material hubs',
    value: 'MThubs',
  },
  {
    label: 'Status',
    value: 'status',
  },
  // {
  //   label: 'Status',
  //   value: 'status',
  // },
  // {
  //   label: 'My trips',
  //   action: ['edit'],
  // },
  // {
  //   label: 'Action',
  //   value: 'commitmentEdit',
  // },

  {
    action: ['edit'],
  }
]

const roleColumns: ReadonlyArray<Column<any>> = columnGenerators(header)

export { roleColumns }